import React, { useEffect, useState } from 'react';
import styles from './MyStations.module.css';
import { useNavigate } from "react-router-dom";
import config from '../../../settings/config';
import { toast } from "react-toastify";
import Header from '../../Utils/Header/Header';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ministation from "../../../img/Station.png";
import steelStation from "../../../img/steelStation5.png";
import classNames from 'classnames';
import localeRu from '../../../locales/ru/stations/myStations.json';
import localeEn from '../../../locales/en/stations/myStations.json';
import useAuthToken from "../../../hooks/useAuthToken";
import useStateBackend from "../../../hooks/useStateBackend";
import useLongPress from "../../../hooks/useLongPress";
import CustomModal from '../../Utils/CustomModal';
import achub from "../../../img/StationHub.png";
import achubsteel from "../../../img/steelStation5AcHub.png";

const MyStations = () => {
    const [stations, setStations] = useState([]);

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        beforeChange: (_, next) => {
            setCurrentStation(stations[next]);
        },
        appendDots: dots => (
            <div
                style={{
                    backgroundColor: 'transparent', // убрали фон
                    padding: '10px',
                    opacity: 1,
                }}
            >
                <ul style={{ margin: 0, display: 'flex', justifyContent: 'center' }}>
                    {dots}
                </ul>
            </div>
        ),
        customPaging: i => (
            <div
                style={{
                    width: '16px',
                    height: '16px',
                    borderRadius: '50%',
                    backgroundColor: '#2F2F2F',
                    transition: 'background-color 0.3s',
                }}
            />
        ),
    };
    const navigate = useNavigate();
    const [currentStation, setCurrentStation] = useState(null);
    const [showModal, setShowModal] = useState(false);
    let lang = localStorage.getItem('language') === 'ru';
    const [delSt, setDelSt] = useState(null);
    const [delStName, setDelStName] = useState(null);

    const token = useAuthToken();
    useStateBackend();

    const handleLongPress = () => {
        setDelSt(currentStation?.sn);
        setDelStName(currentStation?.nickName);
        setShowModal(true);
    };

    const longPressProps = useLongPress(handleLongPress, 1000); // 1 секунда

    const changeStatusLanguage = (status, isAlive) => {
        switch (status) {
            case 'Preparing':
                if (isAlive) {
                    return lang ? 'Ожидание' : 'Preparing';
                } else {
                    return lang ? 'Нет связи' : "No connection"
                }
            case 'Available':
                if (isAlive) {
                    return lang ? 'Свободно' : 'Available';
                } else {
                    return lang ? 'Нет связи' : "No connection"
                }
            case 'Faulted':
                if (isAlive) {
                    return lang ? 'Ошибка' : 'Error';
                } else {
                    return lang ? 'Нет связи' : "No connection"
                }
            case 'Finishing':
                if (isAlive) {
                    return lang ? 'Завершено' : 'Finishing';
                } else {
                    return lang ? 'Нет связи' : "No connection"
                }
            case 'Charging':
                if (isAlive) {
                    return lang ? 'Идет зарядка' : 'Charging';
                } else {
                    return lang ? 'Нет связи' : "No connection"
                }
            default:
                if (isAlive) {
                    return lang ? 'Статус' : 'Status';
                } else {
                    return lang ? 'Нет связи' : "No connection"
                }
        }
    };

    const selectImageStation = (stationFigure, chargingHub) => {
        if (stationFigure === "012") {
            if (chargingHub) {
                return achubsteel;
            } else {
                return steelStation;
            }
        } else {
            if (chargingHub) {
                return achub;
            } else {
                return ministation;
            }
        }
    }

    const getStyleStatus = (status, isAlive) => {
        if (!isAlive) {
            return styles.statusOff;
        }
        switch (status) {
            case 'Preparing':
                return styles.statusPreparing;
            case 'Available':
                return styles.status;
            case 'Faulted':
                return styles.statusFaulted;
            case 'Finishing':
                return styles.statusFinishing;
            case 'Charging':
                return styles.statusCharging;
            default:
                return styles.status;
        }
    };

    const getStyleLighting = (status, isAlive) => {
        if (!isAlive) {
            return styles.iconStatusAvailable;
        }
        switch (status) {
            case 'Preparing':
                return styles.iconStatusPreparing;
            case 'Available':
                return styles.iconStatusAvailable;
            case 'Charging':
                return styles.iconStatusCharge;
            default:
                return styles.iconStatusAvailable;
        }
    };

    const getStyleAlive = (status) => {
        if (status) {
            return styles.card;
        } else {
            return styles.mainSectionOff;
        }
    };

    const getStyleTypeAlive = (status) => {
        if (status) {
            return styles.paramContainer;
        } else {
            return styles.paramContainerOff;
        }
    };

    useEffect(() => {
        changeStatusLanguage(currentStation?.connectors[0]?.status, currentStation?.isAlive);
        getStyleStatus(currentStation?.connectors[0]?.status, currentStation?.isAlive);
        getStyleAlive(currentStation?.connectors[0]?.status);
        getStyleTypeAlive(currentStation?.connectors[0]?.status);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${config.app.host}/api/v1/station/list`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                if (!response.ok) {
                    const result = await response.json();
                    toast.error(`${lang ? localeRu.error : localeEn.error} ${result}`, {
                        position: "top-center",
                        autoClose: 3000,
                        style: { color: "white", backgroundColor: "black" },
                    });
                }
                const result = await response.json();
                result.sort((a, b) => a.id - b.id);
                setStations(result);
            } catch (error) {
                // Обработка ошибок
            }
        };

        fetchData();
        const intervalId = setInterval(fetchData, 5000);
        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        if (stations.length > 0 && !currentStation) {
            setCurrentStation(stations[0]);
        } else if (currentStation) {
            const foundStation = stations.find(station => station.nickName === currentStation.nickName);
            if (foundStation) {
                setCurrentStation(foundStation);
            }
        }
    }, [stations, currentStation]);

    //Отключение вывода контекстного меню
    useEffect(() => {
        const disableContextMenu = (event) => {
            event.preventDefault();
        };

        document.addEventListener("contextmenu", disableContextMenu);

        return () => {
            document.removeEventListener("contextmenu", disableContextMenu);
        };
    }, []);

    const handleConnect = () => {
        navigate('/connect');
    }

    const handleProfile = () => {
        navigate('/profile');
    }

    const handleSupport = () => {
        window.open("https://t.me/PSS_Support_ChargStations_bot", "_blank");
    }

    const confirmDeleteStation = async () => {
        // Выполняем логику выхода, например, очищаем токены и перенаправляем на страницу входа
        let mToken = localStorage.getItem('m_token');
        let resp = '';

        if (mToken) {
            try {
                const response = await fetch(`${config.app.host}/api/v1/station/delete/?sn=${delSt}`, {
                    method: 'GET',
                    mode: 'cors',
                    headers: {
                        'Authorization': `Bearer ${mToken}`,
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    // throw new Error('Network response was not ok');
                    toast.error(`${lang ? localeRu.networkError : localeEn.networkError}`, {
                        position: "top-center",
                        autoClose: 3000,
                        style: { color: "white", backgroundColor: "black" },
                    });
                }

                resp = await response.json();
                if (resp) {
                    // setShowModal(false);
                    // navigate(0); 
                    window.location.reload();
                }
            } catch (error) {
                // setShowModal(false);
                // navigate(0); // Перенаправляем на страницу входа
                window.location.reload()
            }
            toast.success(lang ? `Станция c серийным номером ${delStName} удалена!` : `Station with serial number ${delStName} has been deleted!`, {
                position: "top-center",
                autoClose: 3000,
                style: { color: "white", backgroundColor: "black" },
            });
        }
        // toast.success(
        //     (lang ? localeRu.stationDeleted : localeEn.stationDeleted).replace("{nickName}", delStName),
        //     {
        //         position: "top-center",
        //         autoClose: 3000
        //     }
        // );
        window.location.reload();
        // setShowModal(false);
        // navigate(0); // Перенаправляем на страницу входа
    };

    const handleCardClick = (station) => {
        if (station.isAlive) {
            navigate('/stationControl', { state: { station } });
        } else {
            toast.error(`${lang ? localeRu.no_connect_with_station : localeEn.no_connect_with_station}`, {
                position: "top-center",
                autoClose: 3000,
                style: { color: "white", backgroundColor: "black" },
            });
        }
    };

    return (
        <div className={styles.container}>
            <Header title={lang ? localeRu.my_stations : localeEn.my_stations} />
            <div className={stations?.length === 0 ? styles.section : styles.hidden}>
                <p className={styles.mainText}>{localStorage.getItem('language') === 'ru' ? localeRu.no_stations : localeEn.no_stations} </p>
            </div>
            <div className={stations?.length > 0 ? styles.mainSection : styles.hidden} >
                {stations?.length > 1 ? (
                    <Slider {...sliderSettings}>
                        {stations?.map((station, index) => (
                            <div
                                key={index}
                                // className={styles.card }
                                className={classNames(styles.card, getStyleAlive(currentStation?.isAlive))}
                                onClick={() => handleCardClick(station)}
                                {...(!station.isAlive && longPressProps)}>
                                    
                                <div className={styles.information}>
                                    <div className={classNames(styles.status, getStyleLighting(station?.connectors[0]?.status, station.isAlive))}></div>

                                    <div className={styles.infoLine}>
                                        <p className={styles.paramText}>{changeStatusLanguage(station?.connectors[0]?.status, station.isAlive)}</p>
                                        <div className={styles.stationInformation}>
                                            <p className={styles.paramText}>{stations[0]?.connectors[0]?.type}</p>
                                            <p className={styles.paramText}>{station.powerCp}{lang ? "кBт" : "kW"}</p>
                                        </div>

                                    </div>
                                </div>
                                <div className={styles.imageContainer}>
                                    <img
                                        src={selectImageStation(currentStation?.figure, currentStation?.chargingHub)}
                                        className={styles.miniStation}
                                        alt='ministation'
                                        onContextMenu={(e) => e.preventDefault()} />
                                </div>
                                <div className={styles.nickName}>
                                    <p className={styles.textStationName}>{station.nickName}</p>
                                </div>
                            </div>
                        ))}
                    </Slider>
                ) : (
                    <div
                        className={classNames(styles.card, getStyleAlive(stations[0]?.isAlive))}
                        onClick={() => handleCardClick(stations[0])}
                        {...(!stations[0]?.isAlive && longPressProps)}
                    >
                        <div className={styles.information}>
                            <div className={classNames(styles.status, getStyleLighting(stations[0]?.connectors[0]?.status, stations[0]?.isAlive))}></div>

                            <div className={styles.infoLine}>
                                <p className={styles.paramText}>{changeStatusLanguage(stations[0]?.connectors[0]?.status, stations[0]?.isAlive)}</p>
                                <div className={styles.stationInformation}>
                                    <p className={styles.paramText}>{stations[0]?.connectors[0]?.type}</p>
                                    <p className={styles.paramText}>{stations[0]?.powerCp}{lang ? "кBт" : "kW"}</p>
                                </div>

                            </div>
                        </div>
                        <div className={styles.imageContainer}>
                            <img
                                src={selectImageStation(stations[0]?.figure, stations[0]?.chargingHub)}
                                className={styles.miniStation}
                                alt='ministation'
                                onContextMenu={(e) => e.preventDefault()}
                            />
                        </div>
                        <div className={styles.nickName}>
                            <p className={styles.textStationName}>{stations[0]?.nickName}</p>
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.sectionButtons}>
                <div className={styles.skipContainer}>
                    <button
                        type="button"
                        onClick={handleConnect}
                        className={styles.submitButtonConnect}
                    >
                        <p className={styles.textButtons}>{localStorage.getItem('language') === 'ru' ? localeRu.add_station : localeEn.add_station} </p>
                    </button>
                </div>
            </div>
            <CustomModal
                show={showModal}
                onClose={() => setShowModal(false)}
                onConfirm={confirmDeleteStation}
                textMsg={lang ? localeRu.deleteConfirmTitle : localeEn.deleteConfirmTitle}
                textQuestions={lang ? localeRu.deleteConfirmText : localeEn.deleteConfirmText}
                yes={lang ? "Да" : "Yes"}
                no={lang ? "Нет" : "No"}
            />
        </div>
    );
}

export default MyStations;